import { InputNumber } from "primereact/inputnumber";

interface IInputNumberProps {
  id?: string;
  testId?: string;
  value: number | undefined;
  useGrouping?: boolean;
  onValueChange: (event: any) => void;
  className?: string;
  min?: number;
  max?: number;
  maxFractionDigits?: number;
  styleValue?: string;
  onBlur?: (event: any) => void;
  invalid?: boolean;
  mode?: "decimal" | "currency";
  inputName?: string;
}

const REIInputNumber: React.FC<IInputNumberProps> = ({
  id,
  testId,
  value,
  onValueChange,
  useGrouping = false,
  className,
  min,
  max,
  maxFractionDigits,
  styleValue,
  onBlur,
  invalid,
  mode,
  inputName,
}) => {
  return (
    <InputNumber
      inputId={id}
      data-testid={testId ?? id}
      value={value}
      onValueChange={onValueChange}
      useGrouping={useGrouping}
      className={className}
      min={min}
      max={max}
      maxFractionDigits={maxFractionDigits}
      onBlur={onBlur}
      invalid={invalid}
      mode={mode}
      name={inputName}
    />
  );
};

export default REIInputNumber;
